import { createFeatureSelector, createSelector } from '@ngrx/store';

import { SiteState } from './site.reducer';

export const getSiteState = createFeatureSelector<SiteState>('site');

export const sites = createSelector(getSiteState, (state) => state.sites);
export const isSitesLoaded = createSelector(getSiteState, (state) => state.isSitesLoaded);
export const sitesError = createSelector(getSiteState, (state) => state.sitesError);
export const getSiteById = (siteId: string) =>
    createSelector(getSiteState, (state) => state.sites.find((site) => site.id === siteId));

export const getSiteManagePermissions = (siteId: string) =>
    createSelector(
        getSiteState,
        (state) => state.sites.find((site) => site.id === siteId).permissions.manageReports,
    );

export * as SiteSelectors from './site.selectors';
